// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  flex-direction: column;
  background: #16171F;
  color: white;
  position: absolute;
  min-width: 800px !important;
  min-height: 800px !important;
  top: 5%;
  left: 5%;
  right: 5%;
  bottom: 5%;
  z-index: 5005;
  font-size: 100%;
}
.container .header {
  -webkit-user-select: none;
          user-select: none;
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  align-items: center;
  font-size: 170%;
  height: 7%;
  margin-bottom: 1%;
  background: #22242D;
  padding-left: 2%;
}
.container .header .all-screens-count {
  background: #000;
  color: #66BBFF;
  padding: 5px 60px;
  margin-left: 63%;
}
.container .body {
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  min-height: 0%;
}
.container .close {
  cursor: pointer;
  padding: 15px 25px 15px 25px;
}
.container .close:hover {
  background: rgba(255, 255, 255, 0.05);
}
.container .close.active {
  background: rgba(255, 255, 255, 0.25);
}
.container .header a {
  margin-left: auto;
}
.container.right {
  border-right: none;
  border-left: 2px solid rgba(0, 0, 0, 0.95);
  left: 50%;
  right: 0;
}
.container .pages-list,
.container .widgets-list, .container .selected-widgets-list {
  list-style: none;
  overflow-y: auto;
}
.container .pages-list li,
.container .widgets-list li, .container .selected-widgets-list li {
  display: flex;
  cursor: pointer;
  flex-direction: row;
  align-items: center;
  padding: 25px;
}
.container .pages-list {
  text-align: center;
  width: 12%;
  font-size: 150%;
  margin-right: 3%;
}
.container .pages-list .active {
  background: #66BBFF;
}
.container .pages-list li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  -webkit-user-select: none;
          user-select: none;
  height: 97px;
}
.container .pages-list li .badge {
  color: wheat;
  font-size: 130%;
  padding-right: 10px;
}
.container .pages-list li .template-title {
  font-size: 200%;
  border: 2px solid #32506D;
  padding: 10% 18%;
}
.container .pages-list .page-list-title {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  padding: 25px;
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
}
.container .pages-list .page-list-title .badge {
  color: wheat;
}
.container .pages-list-loading {
  margin-top: -45%;
}
.container .widgets-list {
  width: 58%;
  margin-left: 2%;
  font-size: 150%;
}
.container .widgets-list li {
  -webkit-user-select: none;
          user-select: none;
  height: 20%;
}
.container .widgets-list li:hover {
  background: rgba(255, 255, 255, 0.05);
}
.container .widgets-list li img {
  margin-right: 30px;
  width: 30%;
  min-width: 30%;
}
.container .widgets-list li .title {
  text-align: left;
  line-height: 30px;
  width: 36%;
}
.container .widgets-list li .number-path {
  text-align: left;
  line-height: 30px;
  width: 8%;
  font-size: 26px;
}
.container .widgets-list .widgets-list-title {
  padding-left: 3%;
  -webkit-user-select: none;
          user-select: none;
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  height: 33px;
  background: #16171F;
}
.container .widgets-list .no-widget {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 15%;
}
.container .widgets-list-loading {
  margin-top: -45%;
}
.container .right-side {
  width: 30%;
  -webkit-user-select: none;
          user-select: none;
}
.container .right-side-title {
  display: flex;
  flex-direction: row;
  width: 100%;
}
.container .right-side-title-left, .container .right-side-title-right {
  font-size: 150%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  height: 100%;
}
.container .right-side-button {
  background: #000;
  color: #66BBFF;
  padding: 5px 60px;
  position: absolute;
  width: 22%;
  height: 6%;
  right: 4%;
  bottom: 4%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 150%;
}
.container .right-side .selected-widgets-list {
  width: 100%;
  height: 80%;
  font-size: 150%;
  margin-bottom: 7%;
}
.container .right-side .selected-widgets-list .no-widget {
  display: flex;
  justify-content: center;
  align-items: center;
}
.container .right-side .selected-widgets-list-numberpath {
  width: 22%;
}
.container .right-side .selected-widgets-list li {
  cursor: default;
}
.container .right-side .selected-widgets-list li .selected-widgets-list-image {
  position: relative;
  width: 100%;
  height: 100%;
  cursor: default;
}
.container .right-side .selected-widgets-list li .selected-widgets-list-image .remove-widget {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border-radius: 50%;
  background: #66BBFF;
  width: 1.5em;
  height: 1.5em;
  position: absolute;
  top: -8%;
  right: 7%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 1%;
}
.container .right-side .selected-widgets-list li img {
  margin-right: 30px;
  width: 90%;
}
.container .right-side .selected-widgets-list li span {
  text-align: left;
  line-height: 30px;
  margin-right: 2%;
  font-size: 200%;
  color: #66BBFF;
}

::-webkit-scrollbar {
  width: 10px;
  height: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/components/add-widget-dialog/add-widget-dialog.component.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,4BAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;AAAF;AACE;EACE,yBAAA;UAAA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AACJ;AAAI;EACE,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AAEN;AACE;EACI,aAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AACN;AAGE;EACE,eAAA;EACA,4BAAA;AADJ;AAEI;EACE,qCAAA;AAAN;AAEI;EACI,qCAAA;AAAR;AAGE;EACE,iBAAA;AADJ;AAGE;EACI,kBAAA;EACA,0CAAA;EACA,SAAA;EACA,QAAA;AADN;AAGE;;EAEI,gBAAA;EACA,gBAAA;AADN;AAEM;;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;AACV;AAEE;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;AAAJ;AAEI;EACE,mBAAA;AAAN;AAEI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,YAAA;AAAN;AAEM;EACE,YAAA;EACA,eAAA;EACA,mBAAA;AAAR;AAEM;EACE,eAAA;EACA,yBAAA;EACA,gBAAA;AAAR;AAGI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AADN;AAEM;EACE,YAAA;AAAR;AAKE;EACE,gBAAA;AAHJ;AAKE;EACE,UAAA;EACA,eAAA;EACA,eAAA;AAHJ;AAII;EACE,yBAAA;UAAA,iBAAA;EACA,WAAA;AAFN;AAGM;EACE,qCAAA;AADR;AAGM;EACE,kBAAA;EACA,UAAA;EACA,cAAA;AADR;AAGM;EACE,gBAAA;EACA,iBAAA;EACA,UAAA;AADR;AAGM;EACE,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,eAAA;AADR;AAKI;EACE,gBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,gBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAHN;AAKI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AAHN;AAME;EACE,gBAAA;AAJJ;AAQE;EACE,UAAA;EACA,yBAAA;UAAA,iBAAA;AANJ;AAQI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AANN;AAQM;EACE,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;AANR;AAUI;EACE,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AARN;AAUI;EACE,WAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;AARN;AASM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAPR;AAWM;EACE,UAAA;AATR;AAWM;EACE,eAAA;AATR;AAUQ;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AARV;AAUU;EACE,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EAEA,uBAAA;EAEA,mBAAA;EACA,kBAAA;AARZ;AAWQ;EACE,kBAAA;EACA,UAAA;AATV;AAWQ;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AATV;;AAgBA;EACA,WAAA;EACA,WAAA;AAbA","sourcesContent":["\r\n.container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: #16171F;\r\n  color: white;\r\n  position: absolute;\r\n  min-width: 800px !important;\r\n  min-height: 800px !important;\r\n  top: 5%;\r\n  left: 5%;\r\n  right: 5%;\r\n  bottom: 5%;\r\n  z-index: 5005;\r\n  font-size: 100%;\r\n  .header {\r\n    user-select: none;\r\n    display: flex;\r\n    flex-direction: row;\r\n    flex-shrink: 0;\r\n    align-items: center;\r\n    font-size: 170%;\r\n    height: 7%;\r\n    margin-bottom: 1%;\r\n    background: #22242D;\r\n    padding-left: 2%;\r\n    .all-screens-count {\r\n      background: #000;\r\n      color: #66BBFF;\r\n      padding: 5px 60px;\r\n      margin-left: 63%;\r\n    }\r\n  }\r\n  .body {\r\n      display: flex;\r\n      flex-grow: 1;\r\n      flex-direction: row;\r\n      min-height: 0%;\r\n      // height: 80%;\r\n  }\r\n\r\n  .close {\r\n    cursor: pointer;\r\n    padding: 15px 25px 15px 25px;\r\n    &:hover {\r\n      background: transparentize(#FFF, 0.95);\r\n    }\r\n    &.active {\r\n        background: transparentize(#FFF, 0.75);\r\n    }\r\n  }\r\n  .header a {\r\n    margin-left: auto;\r\n  }\r\n  &.right {\r\n      border-right: none;\r\n      border-left: 2px solid transparentize(#000, 0.05);\r\n      left: 50%;\r\n      right: 0;\r\n  }\r\n  .pages-list,\r\n  .widgets-list, .selected-widgets-list {\r\n      list-style: none;\r\n      overflow-y: auto;\r\n      li {\r\n          display: flex;\r\n          cursor: pointer;\r\n          flex-direction: row;\r\n          align-items: center;\r\n          padding: 25px;\r\n      }\r\n  }\r\n  .pages-list {\r\n    text-align: center;\r\n    width: 12%;\r\n    font-size: 150%;\r\n    margin-right: 3%;\r\n\r\n    .active {\r\n      background: #66BBFF;\r\n    }\r\n    li {\r\n      display: flex;\r\n      justify-content: space-between;\r\n      align-items: center;\r\n      user-select: none;\r\n      height: 97px;\r\n\r\n      .badge {\r\n        color: wheat;\r\n        font-size: 130%;\r\n        padding-right: 10px;\r\n      }\r\n      .template-title {\r\n        font-size: 200%;\r\n        border: 2px solid #32506D;\r\n        padding: 10% 18%;\r\n      }\r\n    }\r\n    .page-list-title {\r\n      display: flex;\r\n      justify-content: space-between;\r\n      flex-direction: row;\r\n      align-items: center;\r\n      padding: 25px;\r\n      cursor: default;\r\n      user-select: none;\r\n      .badge {\r\n        color: wheat;\r\n      }\r\n    }\r\n\r\n  }\r\n  .pages-list-loading {\r\n    margin-top: -45%;\r\n  }\r\n  .widgets-list {\r\n    width: 58%;\r\n    margin-left: 2%;\r\n    font-size: 150%;\r\n    li {\r\n      user-select: none;\r\n      height: 20%;\r\n      &:hover {\r\n        background: transparentize(#FFF, 0.95);\r\n      }\r\n      img {\r\n        margin-right: 30px;\r\n        width: 30%;\r\n        min-width: 30%;\r\n      }\r\n      .title {\r\n        text-align: left;\r\n        line-height: 30px;\r\n        width: 36%;\r\n      }\r\n      .number-path {\r\n        text-align: left;\r\n        line-height: 30px;\r\n        width: 8%;\r\n        font-size: 26px;\r\n      }\r\n\r\n    }\r\n    .widgets-list-title {\r\n      padding-left: 3%;\r\n      user-select: none;\r\n      position: sticky;\r\n      top: 0;\r\n      left: 0;\r\n      width: 100%;\r\n      height: 33px;\r\n      background: #16171F;\r\n    }\r\n    .no-widget {\r\n      display: flex;\r\n      justify-content: center;\r\n      align-items: center;\r\n      height: 15%;\r\n    }\r\n  }\r\n  .widgets-list-loading {\r\n    margin-top: -45%;\r\n  }\r\n\r\n\r\n  .right-side {\r\n    width: 30%;\r\n    user-select: none;\r\n\r\n    &-title {\r\n      display: flex;\r\n      flex-direction: row;\r\n      width: 100%;\r\n\r\n      &-left, &-right {\r\n        font-size: 150%;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        width: 50%;\r\n        height: 100%;\r\n      }\r\n    }\r\n\r\n    &-button {\r\n      background: #000;\r\n      color: #66BBFF;\r\n      padding: 5px 60px;\r\n      position: absolute;\r\n      width: 22%;\r\n      height: 6%;\r\n      right: 4%;\r\n      bottom: 4%;\r\n      display: flex;\r\n      justify-content: center;\r\n      align-items: center;\r\n      font-size: 150%;\r\n    }\r\n    .selected-widgets-list {\r\n      width: 100%;\r\n      height: 80%;\r\n      font-size: 150%;\r\n      margin-bottom: 7%;\r\n      .no-widget {\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n      }\r\n\r\n\r\n      &-numberpath {\r\n        width: 22%;\r\n      }\r\n      li {\r\n        cursor: default;\r\n        .selected-widgets-list-image {\r\n          position: relative;\r\n          width: 100%;\r\n          height: 100%;\r\n          cursor: default;\r\n\r\n          .remove-widget {\r\n            cursor: pointer;\r\n            user-select: none;\r\n            border-radius: 50%;\r\n            background: #66BBFF;\r\n            width: 1.5em;\r\n            height: 1.5em;\r\n            position: absolute;\r\n            top: -8%;\r\n            right: 7%;\r\n            display: flex;\r\n            -webkit-box-pack: center;\r\n            justify-content: center;\r\n            -webkit-box-align: center;\r\n            align-items: center;\r\n            padding-bottom: 1%;\r\n          }\r\n        }\r\n        img {\r\n          margin-right: 30px;\r\n          width: 90%;\r\n        }\r\n        span {\r\n          text-align: left;\r\n          line-height: 30px;\r\n          margin-right: 2%;\r\n          font-size: 200%;\r\n          color: #66BBFF;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n::-webkit-scrollbar {\r\nwidth: 10px;\r\nheight: 8px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
